export enum OpenShiftAssignedForEnum {
  singleLocation = 'singleLocation',
  locationGroups = 'locationGroups',
}
